import { Component } from '@angular/core';
import { SpinnerComponent } from '@enliven/angular';

@Component({
  selector: 'e360-root-layout',
  standalone: true,
  imports: [SpinnerComponent],
  templateUrl: './root-layout.component.html',
  styleUrls: ['./root-layout.component.scss']
})
export class RootLayoutComponent {}
